import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import mobilePopup from "assets/contents/mobile_popup.png";
import {useIsWhosfan, useMobile} from "../../MobileContext";

function MobileNull() {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const isWhosfan = useIsWhosfan();

  console.log("MobileNull isWhosfan : %s", isWhosfan)

  useEffect(() => {
    const headerTitle = document.querySelector(".mobile-main-title");
    if (headerTitle) {
      headerTitle.style.cssText = `
          display:none`;
    }
    return () => (headerTitle.style.cssText = headerTitle.style.cssText);
  }, []);

  const handleOpenAndBack = (e) => {
    e.preventDefault(); // a 태그 기본 이동 막기
    // 새 탭(창) 오픈: 사용자 클릭 컨텍스트 내에서 호출해야 팝업 차단 회피
    window.open("https://whosfan.io", "_blank", "noopener");

    // 뒤로가기 (히스토리가 없으면 홈으로)
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.replace("/"); // 적절한 기본 경로로 교체 가능
    }
  };

  return (
    <div id="mobile-null" className="mobile-null">
      <div className="mobile-null-contents">
        <div className="text-container">
          {t("mobilePopup.serviceInfo")}
          <br />
          <strong>{t("mobilePopup.checkOnPC")}</strong>
        </div>

        <div className="img-container">
          <img className="img" src={mobilePopup} alt="" />
        </div>
        <div className="btn-container">
          <div className="download-app">
            <a
                href="https://whosfan.io"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleOpenAndBack}
            >
              {t("mobilePopup.ok")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileNull;
